import { fetchDatalakeFile } from '@/utils/datalake';

export const downloadJsonFileFromDatalake = async (
  fileName: string,
  groupName: string
): Promise<any> => {
  return fetchDatalakeFile({ fileName, groupName });
};
